module.exports = __webpack_public_path__ + "img/rm.12ee0303.svg";